<script setup>
defineProps({
  error: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<template>
  <div>
    <div class="error">
      <div class="error__content">
        <div class="error__text">
          <span class="error__code">{{ error.statusCode }}</span>
          <h1 v-if="error.statusCode === 404" class="error__title">
            Этой страницы не существует, <br />
            как и свободы слова в России
          </h1>
          <h1 v-else class="error__title">Что-то пошло не так...</h1>
        </div>

        <div class="error__television">
          <img src="/images/tv.png" alt="TV" class="error__image" />
          <video autoplay loop muted playsinline class="error__video">
            <source
              src="/videos/video.av1.mp4"
              type="video/mp4; codecs=av01.0.05M.08,opus"
            />
            <source
              src="/videos/video.hevc.mp4"
              type="video/mp4; codecs=hvc1"
            />
            <source
              src="/videos/video.h264.mp4"
              type="video/mp4; codecs=avc1.4D401E,mp4a.40.2"
            />
          </video>
        </div>
      </div>

      <NuxtLink :to="{ name: 'index' }" class="error__button">
        На главную
      </NuxtLink>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.error {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 60px 0;
  background: linear-gradient(0deg, rgb(62, 39, 81) 0%, var(--black-color) 50%);
  pointer-events: none;

  &__content {
    position: relative;
    width: min-content;
  }

  &__text {
    position: absolute;
    top: -55px;
    left: -220px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    white-space: nowrap;
    color: rgb(235, 235, 235);
  }

  &__code {
    font-family: var(--title-font-family);
    font-weight: 700;
    font-size: 68px;
    line-height: 98px;
  }

  &__title {
    font-size: 28px;
    line-height: 41px;
  }

  &__television {
    position: relative;
    width: 520px;
    height: 505px;
    margin-bottom: 30px;
  }

  &__image {
    position: absolute;
    top: 0;
    left: -22px;
    width: 520px;
    height: 505px;
    z-index: 2;
  }

  &__video {
    position: absolute;
    z-index: 1;
    top: 144px;
    left: 55px;
    width: 329px;
    height: 340px;
  }

  &__button {
    pointer-events: all;
    width: 351px;
    padding: 16px 0;
    background-color: var(--green-color);
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    border-radius: 12px;
    transition: var(--default-transition) opacity;

    &:hover {
      opacity: 0.7;
    }
  }

  @media (--medium-vp) {
    &__text {
      top: -55px;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }

  @media (--small-vp) {
    &__text {
      top: -78px;
    }

    &__code {
      font-size: 42px;
      line-height: 61px;
    }

    &__title {
      font-size: 18px;
      line-height: 26px;
    }

    &__television {
      width: 276px;
      height: 290px;
      margin-bottom: 30px;
    }

    &__image {
      left: -10px;
      width: 276px;
      height: 290px;
    }

    &__video {
      top: 115px;
      left: 26px;
      width: 188px;
      height: 138px;
    }
  }

  @media (--small-vp) {
    &__button {
      position: absolute;
      bottom: 20px;
    }
  }
}
</style>
